/**
 *
 * @type {{ADD_BASKET_ITEM: string, CLEAR_BASKET: string, REMOVE_BASKET_ITEM: string}}
 */
import { apipost, apiget } from "../../api";

export const types = {
  EXPORT_A4_PROJECT: "EXPORT_A4_PROJECT",
  GET_RENDERING_PAYLOAD: "GET_RENDERING_PAYLOAD",
  EXPORT_ZIP: "EXPORT_ZIP"
};

/**
 *
 * @type {{}}
 */
export const actions = {
  [types.EXPORT_A4_PROJECT]: token => async (_, payload) =>
    await apipost("/render/project/a4", payload, token),
  [types.GET_RENDERING_PAYLOAD]: token => async (_, key) =>
    await apiget("/render/payload/" + key, {}, token),
  [types.EXPORT_ZIP]: token => async (_, { projects, options }) =>
    await apipost(
      `/render/zip/${projects.map(p => p.id).join(",")}`,
      { options },
      token
    )
};
